import React from "react";
import ReactDOM from "react-dom";
import "intersection-observer";
import 'url-search-params-polyfill';
import "./css/bootstrap.css";
import "./css/font.css";
import "./css/form.css";
import "./css/custom.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
